import styled from 'styled-components';
import { defaultColor } from 'styles/theme';

// Global reset (`* { margin: 0; padding: 0 }`) strips the browser defaults the editor output relies on.
export const Content = styled.div`
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: ${({ $plain }) => ($plain ? 'pre-line' : 'normal')};

  p { margin-bottom: 0.5em; }
  p:last-child { margin-bottom: 0; }
  h2 { font-size: 1.3em; margin-bottom: 0.5em; }
  ul, ol { padding-left: 1.5em; margin-bottom: 0.5em; }
  ul { list-style: disc; }
  ol { list-style: decimal; }
  blockquote {
    margin-bottom: 0.5em;
    padding-left: 0.75em;
    border-left: 3px solid ${defaultColor('metallic')};
    color: ${defaultColor('metallic')};
  }
`;
